export default {
  namespaced: true,
  state: () => ({
    buildList: [],
    outsideList: [],
    floorRow: '',
    hyHead: null,
    hyHguid: null,
    xmHead: null,
    xmHguid: null,
    xmMbguid: null,
    xmRow: {},
    xmUpgrade: false,
    xmVersions: null,
    hyDetail: {},
    lyDetail: {}
  }),
  mutations: {
    SET_FLOOR_ROW(state, value) {
      state.floorRow = value;
    },
    SET_BUILD_LIST(state, value) {
      state.buildList = value;
    },
    SET_OUTSIDE_LIST(state, value) {
      state.outsideList = value;
    },
    SET_HY_HEAD(state, value) {
      state.hyHead = value;
    },
    SET_HY_HGUID(state, value) {
      state.hyHguid = value;
    },
    SET_XM_HEAD(state, value) {
      state.xmHead = value;
    },
    SET_XM_HGUID(state, value) {
      state.xmHguid = value;
    },
    SET_XM_ROW(state, value) {
      state.xmRow = value;
    },
    SET_XM_MBGUID(state, value) {
      state.xmMbguid = value;
    },
    SET_XM_UPGRADE(state, value) {
      state.xmUpgrade = value;
    },
    SET_XM_VERSIONS(state, value) {
      state.xmVersions = value;
    },
    SET_LY_DETAIL(state, value) {
      state.lyDetail = value;
    },
    SET_HY_DETAIL(state, value) {
      state.hyDetail = value;
    }
  },
  actions: {
    setFloorRow({
      commit
    }, payload) {
      commit('SET_FLOOR_ROW', payload);
    },
    setBuildList({
      commit
    }, payload) {
      commit('SET_BUILD_LIST', payload);
    },
    setOutsideList({
      commit
    }, payload) {
      commit('SET_OUTSIDE_LIST', payload);
    },
    setHyHead({
      commit
    }, payload) {
      commit('SET_HY_HEAD', payload);
      if (payload) {
        localStorage.setItem('hy_head', JSON.stringify(payload));
      } else {
        localStorage.removeItem('hy_head');
      }
    },
    setHyHguid({
      commit
    }, payload) {
      commit('SET_HY_HGUID', payload);
      console.log(payload);
      if (payload) {
        localStorage.setItem('hy_hguid', payload);
      } else {
        localStorage.removeItem('hy_hguid');
      }
    },
    setXmHead({
      commit
    }, payload) {
      commit('SET_XM_HEAD', payload);
      if (payload) {
        localStorage.setItem('xm_head', JSON.stringify(payload));
      } else {
        localStorage.removeItem('xm_head');
      }
    },
    setXmHguid({
      commit
    }, payload) {
      commit('SET_XM_HGUID', payload);
      if (payload) {
        localStorage.setItem('xm_hguid', payload);
      } else {
        localStorage.removeItem('xm_hguid');
      }
    },
    setXmRow({
      commit
    }, payload) {
      commit('SET_XM_ROW', payload);
      if (payload) {
        localStorage.setItem('xm_row', JSON.stringify(payload));
      } else {
        localStorage.removeItem('xm_row');
      }
    },
    setXmMbguid({
      commit
    }, payload) {
      commit('SET_XM_MBGUID', payload);
      if (payload) {
        localStorage.setItem('xm_Mbguid', payload);
      } else {
        localStorage.removeItem('xm_Mbguid');
      }
    },
    setXmUpgrade({
      commit
    }, payload) {
      commit('SET_XM_UPGRADE', payload);
      if (payload) {
        localStorage.setItem('xm_upgrade', payload);
      } else {
        localStorage.removeItem('xm_upgrade');
      }
    },
    setXmVersions({
      commit
    }, payload) {
      commit('SET_XM_VERSIONS', payload);
      if (payload) {
        localStorage.setItem('xm_versions', JSON.stringify(payload));
      } else {
        localStorage.removeItem('xm_versions');
      }
    },
    setLyDetail({
      commit
    }, payload) {
      commit('SET_LY_DETAIL', payload);
    },
    setHyDetail({
      commit
    }, payload) {
      commit('SET_HY_DETAIL', payload);
    }
  },
  getters: {
    getFloorRow(state) {
      return state.floorRow;
    },
    getBuildList(state) {
      return state.buildList;
    },
    getOutsideList(state) {
      return state.outsideList;
    },
    getHyHead(state) {
      const localHead = localStorage.getItem('hy_head');
      return localHead ? JSON.parse(localHead) : state.hyHead;
    },
    getHyHguid(state) {
      return state.hyHguid || localStorage.getItem('hy_hguid');
    },
    getXmHead(state) {
      const localHead = localStorage.getItem('xm_head');
      return localHead ? JSON.parse(localHead) : state.xmHead;
    },
    getXmHguid(state) {
      return state.xmHguid || localStorage.getItem('xm_hguid');
    },
    getXmRow(state) {
      const xmRow = localStorage.getItem('xm_row');
      return xmRow ? JSON.parse(xmRow) : state.xmRow;
    },
    getXmMbguid(state) {
      return state.xmMbguid || localStorage.getItem('xm_Mbguid');
    },
    getXmUpgrade(state) {
      return state.xmUpgrade || localStorage.getItem('xm_upgrade');
    },
    getXmVersions(state) {
      const xmVersions = localStorage.getItem('xm_versions');
      return xmVersions ? JSON.parse(xmVersions) : state.xmVersions;
    },
    getLyDetail(state) {
      return state.lyDetail;
    },
    getHyDetail(state) {
      return state.hyDetail;
    }
  }
};